import { config } from 'zod';

/**
 * Must be imported before any module that builds a zod schema.
 *
 * zod decides whether to JIT-compile object validators while the schema is being
 * *constructed*, not when it parses:
 *
 *   // zod/v4/core/schemas.js
 *   const jit = !core.globalConfig.jitless;
 *   const fastEnabled = jit && allowsEval.value;   // .value runs the probe
 *
 * `allowsEval` is a `cached()` getter whose body runs `new Function('')` inside a
 * try/catch. The throw is swallowed, but a strict Content-Security-Policy still
 * reports it — zod says so itself at `v4/core/util.js:146`. Because `&&` is lazy,
 * setting `jitless` means `allowsEval.value` is never dereferenced and the probe
 * never runs.
 *
 * Two consequences worth knowing:
 *
 *   1. `cached()` memoises, so only the FIRST schema construction matters. Setting
 *      this later is a silent no-op — which is why it cannot live in the component
 *      that owns the form, or in the body of `main.tsx` (ES imports are hoisted and
 *      evaluated before any statement in the importing module runs).
 *   2. It costs nothing under our CSP. With `script-src` excluding 'unsafe-eval'
 *      the probe would fail anyway and zod would take the non-JIT path. Setting it
 *      explicitly just makes dev, report-only and enforcing behave identically
 *      instead of the JIT path being taken wherever eval happens to be permitted.
 *
 * The alternative was adding 'unsafe-eval' to the policy — giving up its strongest
 * directive to satisfy a feature probe that is designed to fail.
 */
config({ jitless: true });
